import {IDynamicTreeContext} from '~/interfaces/dynamicFieldsInterfaces'
import {Logger} from '~/services/logger'

export default {
  props: {
    // info from the parent level useful to this level
    parentTreeContext: {
      type: Object as () => IDynamicTreeContext,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    treeContext(): Partial<IDynamicTreeContext> {
      Logger.errorOnce('handlerTreeContextMixin', '"treeContext" computed property is required but not defined!')
      return {}
    },
    computedChildTreeContext(): IDynamicTreeContext {
      return Object.assign(
        {},
        this.parentTreeContext,
        this.treeContext,
      )
    },
  },
  methods: {
    childTreeContext(childContext: Partial<IDynamicTreeContext> = {}): IDynamicTreeContext {
      return Object.assign(
        {},
        this.computedChildTreeContext,
        childContext,
      )
    },
  }
}